/**
 * @generated SignedSource<<7435c4f93c2f6c499777263ac640bf7d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskOrderTile_transaction$data = {
  readonly item: {
    readonly firstPhotoWebPath: string | null;
    readonly title: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"getOrderStatusLabel_transaction">;
  readonly " $fragmentType": "GetHelpZendeskOrderTile_transaction";
};
export type GetHelpZendeskOrderTile_transaction$key = {
  readonly " $data"?: GetHelpZendeskOrderTile_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskOrderTile_transaction">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GetHelpZendeskOrderTile_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "size",
              "value": "small"
            }
          ],
          "kind": "ScalarField",
          "name": "firstPhotoWebPath",
          "storageKey": "firstPhotoWebPath(size:\"small\")"
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "getOrderStatusLabel_transaction",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCanceled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TransactionCurrentBuyerTimelineStatus",
          "kind": "LinkedField",
          "name": "currentBuyerTimelineStatus",
          "plural": false,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TransactionCurrentSellerTimelineStatus",
          "kind": "LinkedField",
          "name": "currentSellerTimelineStatus",
          "plural": false,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};
})();

(node as any).hash = "14486ddc6b51109b186e0cb78dfc13c3";

export default node;
